var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E5F3FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_2217)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_2217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6849 19.7019H30.2513V13.1704L32.6849 13.1683V19.7019ZM26.4576 20.8153L21.8391 16.1957L20.1184 17.9164L24.7359 22.5349L26.4576 20.8153ZM42.8199 17.9196L41.0982 16.1989L36.4797 20.8153L38.2004 22.536L42.8199 17.9196ZM35.8232 34.0477C37.6975 32.6918 38.9227 30.4934 38.9227 28.0064C38.9217 23.8887 35.589 20.5497 31.4681 20.5476C27.3514 20.5497 24.0146 23.8845 24.0125 28.0043C24.0125 30.4934 25.2366 32.6897 27.111 34.0477V35.0094H35.8221L35.8232 34.0477ZM27.111 37.3709C27.111 38.1916 27.7612 38.8512 28.5735 38.8941C28.7972 39.7617 30.0025 40.4276 31.4671 40.4276C32.9327 40.4276 34.1349 39.7617 34.3628 38.8941C35.174 38.8512 35.8242 38.1937 35.8232 37.3709V37.1608H27.112L27.111 37.3709ZM35.8211 35.6482H27.111V36.4939L35.8221 36.4981L35.8211 35.6482ZM37.9725 39.6562L33.6091 48.199L32.9201 42.6438L33.9979 41.7595H31.3855H29L30.0778 42.6438L29.3878 48.199L25.0275 39.6562C17.4443 40.6796 12 43.9276 12 51.8317H51C50.999 43.9276 45.5536 40.6775 37.9725 39.6562Z",
    fill: "#424242"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_2217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(12 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_2217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreators);
export default __webpack_public_path__ + "static/media/creators.278198333e7fe61a7c884e464ecd9e9a.svg";
export { ForwardRef as ReactComponent };